import { STATUS_DB } from '@/shared/common/types/status.type';
import type { StablecoinStatusTag } from '../types/stablecoinModalDetail.type';

const PENDING_STATUSES: string[] = [
  STATUS_DB.PENDING_VERIFICATION,
  STATUS_DB.EN_REVISION,
  STATUS_DB.REVISANDO_PAGO,
  STATUS_DB.ESPERANDO_PAGO,
  STATUS_DB.UNDER_COMPLIANCE_REVIEW,
];

const REJECTED_STATUSES: string[] = [
  STATUS_DB.CANCELLED,
  STATUS_DB.REJECTED,
  STATUS_DB.CANCELLED_BY_INITIATOR,
  STATUS_DB.REJECTED_BY_RECIPIENT,
  STATUS_DB.CANCELLED_BY_SYSTEM,
  STATUS_DB.DEVUELTO,
  STATUS_DB.ENVIO_ANULADO,
  STATUS_DB.ENVIO_RECHAZADO,
];

/**
 * Mapea el status crudo del movimiento stablecoin a la etiqueta y el tipo
 * de GTag que se muestran en el detalle. Una recepción stablecoin visible
 * en el listado se considera completada por defecto.
 */
export function getStablecoinStatus(status?: string): StablecoinStatusTag {
  if (status && PENDING_STATUSES.includes(status)) {
    return { label: 'Pendiente', type: 'warning' };
  }
  if (status && REJECTED_STATUSES.includes(status)) {
    return { label: 'Rechazado', type: 'error' };
  }
  return { label: 'Completado', type: 'success' };
}
